/**
 * Id клика по плашке списка — по типу плашки, чтобы в аналитике было видно,
 * куда именно человек пытался войти. Тип стоит в самом id, а не в значении
 * кнопки: у гостя уровень значения съедает метка guest (лимит пяти уровней
 * события, см. sendButtonClickEvent):
 *
 *   page:LobbyListPage:button:join_lobby                 — лобби в сборе
 *   page:LobbyListPage:button:join_started_match         — начатый матч
 *   page:LobbyListPage:button:join_private_lobby         — приватное лобби
 *   page:LobbyListPage:button:join_ai_lobby              — «Битва с AI» (в сборе и начатая)
 *   page:LobbyListPage:guest:button:join_started_match   — то же у гостя
 *
 * Приватное проверяется первым: фейковые приватные лобби числятся начатыми.
 * Промо-лобби с ИИ приватным не бывает — у него свой id в любом статусе.
 * Те же id — у плашек телефона и у карточек десктопа
 */
export const LOBBY_LIST_ITEM_BUTTON_IDS = {
  PREPARING: 'join_lobby',
  STARTED: 'join_started_match',
  PRIVATE: 'join_private_lobby',
  AI: 'join_ai_lobby',
};

export const getLobbyItemButtonId = (lobby) => {
  if (lobby.isPrivate) {
    return LOBBY_LIST_ITEM_BUTTON_IDS.PRIVATE;
  }
  if (lobby.isAiMatch) {
    return LOBBY_LIST_ITEM_BUTTON_IDS.AI;
  }
  return lobby.status === 'game_started'
    ? LOBBY_LIST_ITEM_BUTTON_IDS.STARTED
    : LOBBY_LIST_ITEM_BUTTON_IDS.PREPARING;
};

/**
 * Промо-лобби с ИИ — первым в своем разделе (в сборе или начатые): это
 * событие дня, его не должно быть видно только после прокрутки. Порядок
 * остальных лобби — как прислал сервер (сортировка устойчивая)
 */
export const sortAiLobbiesFirst = (list) => [...list].sort(
  (a, b) => Number(Boolean(b.isAiMatch)) - Number(Boolean(a.isAiMatch))
);
